export default "__VITE_ASSET__DCkWnYCr__"